module.exports = __webpack_public_path__ + "media/images/users/user-1-a19e33ffafed82b8b4d81af30d0d5777.jpg";